import * as THREE from 'three';
import { WIND_LEGEND_STOPS, hexToRgb } from '../../constants.js';

export function generateGradientRectangle() {
  const gradientRectangleWidth = 256;
  const gradientRectangleHeight = 1;
  const gradientRectangleData = generateVelocityGradientTexture(
    WIND_LEGEND_STOPS,
    gradientRectangleHeight,
    gradientRectangleWidth
  );

  const gradientTexture = new THREE.DataTexture(
    gradientRectangleData,
    gradientRectangleWidth,
    gradientRectangleHeight,
    THREE.RGBAFormat
  );

  gradientTexture.minFilter = THREE.LinearFilter;
  gradientTexture.magFilter = THREE.LinearFilter;
  gradientTexture.wrapS = THREE.ClampToEdgeWrapping;
  gradientTexture.wrapT = THREE.ClampToEdgeWrapping;
  gradientTexture.colorSpace = THREE.SRGBColorSpace;
  gradientTexture.needsUpdate = true;

  return gradientTexture;
}

function generateVelocityGradientTexture(colorStops, gradientRectangleHeight, gradientRectangleWidth) {
  const gradientRectangleSize = gradientRectangleWidth * gradientRectangleHeight * 4;
  const gradientRectangleData = new Uint8Array(gradientRectangleSize);

  for (let index = 0; index < gradientRectangleWidth; index += 1) {
    const position = index / (gradientRectangleWidth - 1);
    let start = colorStops[0];
    let end = colorStops[colorStops.length - 1];

    for (let stopIndex = 0; stopIndex < colorStops.length - 1; stopIndex += 1) {
      const current = colorStops[stopIndex];
      const next = colorStops[stopIndex + 1];

      if (position >= current.position && position <= next.position) {
        start = current;
        end = next;
        break;
      }
    }

    const range = Math.max(end.position - start.position, 0.0001);
    const localPosition = (position - start.position) / range;
    const startRgb = hexToRgb(start.color);
    const endRgb = hexToRgb(end.color);

    gradientRectangleData[index * 4 + 0] = Math.round(THREE.MathUtils.lerp(startRgb.r, endRgb.r, localPosition));
    gradientRectangleData[index * 4 + 1] = Math.round(THREE.MathUtils.lerp(startRgb.g, endRgb.g, localPosition));
    gradientRectangleData[index * 4 + 2] = Math.round(THREE.MathUtils.lerp(startRgb.b, endRgb.b, localPosition));
    gradientRectangleData[index * 4 + 3] = 255;
  }

  return gradientRectangleData;
}
